import { getUrl, Post, Get, Put, Patch } from '.'

export const List = async body => {
  return Post(getUrl('cnps.css.store-staff.get-list'), body)
}

export const Create = async body => {
  return Post(getUrl('cnps.css.store-staff.create'), body)
}

export const GetAssignment = async body => {
  return Post(getUrl('cnps.css.store-staff.get-assignment'), body)
}

export const AssignMO = async body => {
  return Post(getUrl('cnps.css.store-staff.assign-mo'), body)
}

export const AssignMA = async body => {
  return Post(getUrl('cnps.css.store-staff.assign-ma'), body)
}

export const AssignOrder = async body => {
  return Post(getUrl('cnps.css.assign-order.create'), body)
}

export const AssignStore = async body => {
  return Post(getUrl('cnps.css.store-staff.assign-st'), body)
}

export const historyAssign = async body => {
  return Post(getUrl('cnps.css.store-staff.history-assign'), body)
}
